<template>
  <button
    ref="buttonRef"
    :class="{
      [`tw-bg-${color} tw-text-white`]: !outline && color,
      [`tw-border-${color} tw-text-${color} tw-border tw-bg-white`]:
        outline && color,
      'hover:tw-opacity-70': !disabled,
    }"
    :style="customButtonStyle"
    :loading="loading"
    :disabled="disabled"
    class="global-button"
  >
    <p-inner-loader :visible="loading" :size="loaderSize" />
    <slot />
  </button>
</template>

<script lang="ts" setup>
import { timeout } from '@/utils/time';
import { withDefaults, defineProps, computed, onMounted, ref } from 'vue';

interface Props {
  color?: string;
  loading?: boolean;
  outline?: boolean;
  loaderSize?: string;
  disabled?: boolean;
  forceFullOpacity?: boolean;
  shouldAutoFocus?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
  outline: false,
  loaderSize: '30px',
  disabled: false,
  forceFullOpacity: false,
  shouldAutoFocus: false,
});
const buttonRef = ref<HTMLButtonElement | null>(null);
onMounted(async () => {
  await timeout(500);
  if (props.shouldAutoFocus) {
    buttonRef.value?.focus();
  }
});

const customButtonStyle = computed(() => {
  let styleString = '';
  if (props.forceFullOpacity) {
    styleString += 'opacity: 1 !important';
  }
  return styleString;
});
</script>

<style scoped lang="scss">
.global-button {
  @apply tw-rounded tw-font-bold tw-flex tw-items-center tw-justify-center tw-px-2 tw-text-sm tw-relative;
  min-height: 2rem;

  &:focus-visible {
    outline: 1px solid var(--q-primary);
    outline-offset: 1px;
  }
}
</style>
